import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
    },
    contentBtn: {
        position: 'absolute',
        bottom: 50,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    contentCheckbox: {
        flexDirection: 'row',
        position: 'absolute',
        bottom: 115,
        paddingHorizontal: 25,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    contentPrices: {
        marginBottom: 10
    },
    descriptionPrice: {
        fontSize: 16,
        color: '#939394'
    },
    price: {
        color: '#000',
        fontWeight: 'bold'
    },
    contentPriceSell: {
        flexDirection: 'row',
        justifyContent: 'space-around'
    },
    textInputPriceSell: {
        borderBottomColor: '#939394',
        borderBottomWidth: 2,
        marginBottom: 30,
        width: '65%'
    },
    contentAmount: {
        flexDirection: 'row',
        justifyContent: 'space-around'
    },
    textInputAmount: {
        borderBottomColor: '#939394',
        borderBottomWidth: 2,
        marginBottom: 30,
        width: '88.9%',
        marginTop:  Platform.OS === 'ios' ? 5 : -5
    },
    titlePage: {
        fontSize: 16,
        fontWeight: 'bold',
        paddingVertical: 20,
        textAlign: 'center'
    },
    coin: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#fff',
        backgroundColor: '#3A3A3C',
        height: 25,
        padding: 3
    },
    textInfoPriceSell: {
        fontSize: 16,
        color: '#000',
        fontWeight: 'bold',
        marginTop: Platform.OS === 'ios' ? 0 : 5
    }
});

export default styles;
